import { useUrlParams } from '@bpd-library/utilities';
import { apartmentViewRoute } from '@features/properties/routes/apartment-view';
import { constructionNumberRoute } from '@features/properties/routes/construction-number';
import { propertyTypeRoute } from '@features/properties/routes/property-type';
import { createRoutingHook, Route, Routes } from '@utilities/hooks/use-routing';

const PROPERTIES_ROUTES: Routes = {
    apartmentView: apartmentViewRoute,
    constructionNumber: constructionNumberRoute,
    propertyType: propertyTypeRoute,
    allConstructionNumbers: constructionNumberRoute,
};

function getInitialRoute(): Route {
    const { get: getUrlParam } = useUrlParams();

    const viewMode = getUrlParam('view-mode') as string | undefined;
    const propertyTypeId = getUrlParam('propertytypeId') as string | undefined;
    const apartmentBuildingId = getUrlParam('apartmentBuildingId') as string | undefined;

    if (viewMode) {
        switch (viewMode) {
            case 'construction-numbers':
                return {
                    to: 'allConstructionNumbers',
                };
        }
    } else if (propertyTypeId) {
        return {
            to: 'constructionNumber',
            slug: propertyTypeId,
        };
    } else if (apartmentBuildingId) {
        return {
            to: 'apartmentView',
            slug: apartmentBuildingId,
        };
    }

    return {
        to: 'propertyType',
    };
}

export const usePropertiesRouting = createRoutingHook({
    routes: PROPERTIES_ROUTES,
    defaultRoute: getInitialRoute(),
});
